import Vue from "vue";

const vuemoment = require('vue-moment')
const moment = require('moment')
require('moment/locale/pt-br')

require('moment-timezone');

moment.tz.setDefault('America/Sao_Paulo');

Vue.use(vuemoment, {
  moment
})